// src/utils/tokenWatcher.js
import { notifySessionExpired } from "./sessionBus";

const TOKEN_KEY = "token";
const SKEW_MS = 2000; 

let expiryTimer = null;
let stopFns = [];

const SUPPRESS_ONCE_KEY = "SEM_SUPPRESS_ONCE";

  export function suppressNextTokenChange() {
    try { localStorage.setItem(SUPPRESS_ONCE_KEY, "1"); } catch {}
  }


// Simple Analysis of JWT 
function parseJwt(token) {
  try {
    const base64 = token.split(".")[1].replace(/-/g, "+").replace(/_/g, "/");
    const json = decodeURIComponent(
      atob(base64)
        .split("")
        .map(c => "%" + ("00" + c.charCodeAt(0).toString(16)).slice(-2))
        .join("")
    );
    return JSON.parse(json);
  } catch {
    return null;
  }
}

function isAuthRoute() {
  try {
    const p = window.location?.pathname || "/";
    return ["/", "/login", "/signup", "/forgot-password"].includes(p);
  } catch { return false; }
}

function clearExpiryTimer() {
  if (expiryTimer) {
    clearTimeout(expiryTimer);
    expiryTimer = null;
  }
}

function scheduleExpiryCheck(token) {
  clearExpiryTimer();
  const payload = parseJwt(token);
  const expSec = payload?.exp;
  if (!expSec) return;

  const ms = expSec * 1000 - Date.now() - SKEW_MS;
  if (ms <= 0) {
    // Expired/about to expire: Unauthenticated routes pop up immediately
    if (!isAuthRoute()) notifySessionExpired();
    return;
  }
  expiryTimer = setTimeout(() => {
    if (!isAuthRoute()) notifySessionExpired();
  }, ms);
}

function handleTokenChange() {
  try {
    if (localStorage.getItem(SUPPRESS_ONCE_KEY) === "1") {
      localStorage.removeItem(SUPPRESS_ONCE_KEY);
      clearExpiryTimer();
      return;
    }
  } catch {}

  const token = localStorage.getItem(TOKEN_KEY);
  if (!token) {
    if (!isAuthRoute()) notifySessionExpired(); 
    clearExpiryTimer();
  } else {
    scheduleExpiryCheck(token); 
  }
}

export function startTokenWatcher() {
  handleTokenChange();

  const onStorage = (e) => {
    if (e.key === TOKEN_KEY || e.key === null) {
      handleTokenChange();
    }
  };
  window.addEventListener("storage", onStorage);
  stopFns.push(() => window.removeEventListener("storage", onStorage));

  const origSet = localStorage.setItem.bind(localStorage);
  const origRemove = localStorage.removeItem.bind(localStorage);
  const origClear = localStorage.clear.bind(localStorage);

  localStorage.setItem = function(k, v) {
    origSet(k, v);
    if (k === TOKEN_KEY) handleTokenChange();
  };
  localStorage.removeItem = function(k) {
    origRemove(k);
    if (k === TOKEN_KEY) handleTokenChange();
  };
  localStorage.clear = function() {
    origClear();
    handleTokenChange();
  };

  stopFns.push(() => { localStorage.setItem = origSet; });
  stopFns.push(() => { localStorage.removeItem = origRemove; });
  stopFns.push(() => { localStorage.clear = origClear; });

  return () => stopTokenWatcher();
}

export function stopTokenWatcher() {
  clearExpiryTimer();
  stopFns.forEach(fn => { try { fn(); } catch {} });
  stopFns = [];
}
